import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { ExecWellness } from '../components/widgets/ExecWellness';

export default function ExecWellnessPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="וולנס · אפליקציה" />
        <main className="flex-1 overflow-y-auto p-6">
          <ExecWellness />
        </main>
      </div>
    </div>
  );
}
